
import CrmPageHeader from "@/modules/CRM/components/CrmPageHeader";
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "crm-dashboard",
  components: { CrmPageHeader },
  data() {
    return {
      filtros: this.defaultPeriodo(),
      funis: [],
      loading: false,
      resumo: null,
      statusOptions: [
        { value: "Todos", text: "Todos" },
        { value: "aberta", text: "Abertas" },
        { value: "ganha", text: "Ganhas" },
        { value: "perdida", text: "Perdidas" },
      ],
      temperaturas: [],
      usuarios: [],
    };
  },
  computed: {
    cards() {
      const resumo = this.resumo || {};
      return [
        {
          label: "Abertas",
          value: resumo.oportunidades_abertas || 0,
          hint: "Oportunidades em andamento",
          to: { name: "crmFunil" },
        },
        {
          label: "Valor aberto",
          value: this.formatMoney(resumo.valor_aberto || 0),
          hint: "Receita potencial",
          to: { name: "crmFunil" },
        },
        {
          label: "Próximas tarefas",
          value: this.tarefasCriticas.length,
          hint: this.tarefasAtrasadasLabel,
          to: { name: "crmTarefas" },
        },
        {
          label: "Agenda próxima",
          value: this.agendaCritica.length,
          hint: this.agendaProximaLabel,
          to: { name: "crmAgenda" },
        },
        {
          label: "Paradas",
          value: resumo.oportunidades_paradas || 0,
          hint: "Sem movimento há 7+ dias",
          to: { name: "crmFunil" },
        },
        {
          label: "Sem próxima ação",
          value: resumo.oportunidades_sem_proxima_acao || 0,
          hint: "Sem data definida para agir",
          to: { name: "crmFunil" },
        },
      ];
    },
    agendaProximaLabel() {
      const total = this.agendaCritica.length;
      return total
        ? `${total} compromisso(s) próximo(s) em destaque.`
        : "Sem compromisso crítico próximo.";
    },
    agendaCritica() {
      return this.resumo?.agenda_critica || [];
    },
    funilAtalhoLabel() {
      const resumo = this.resumo || {};
      return `${resumo.oportunidades_abertas || 0} aberta(s) · ${
        resumo.oportunidades_paradas || 0
      } parada(s).`;
    },
    funilOptions() {
      return [{ value: null, text: "Todos" }].concat(
        this.funis.map((funil) => ({
          value: funil.id_crm_funil,
          text: funil.nome,
        }))
      );
    },
    oportunidadesCriticas() {
      return this.resumo?.oportunidades_criticas || [];
    },
    oportunidadesGanhas() {
      return this.resumo?.oportunidades_ganhas || [];
    },
    periodoLabel() {
      return `${this.formatDate(
        this.filtros.data_inicio
      )} até ${this.formatDate(this.filtros.data_fim)}`;
    },
    tarefasCriticas() {
      return this.resumo?.tarefas_criticas || [];
    },
    tarefasAtrasadasLabel() {
      const total = this.resumo?.tarefas_atrasadas || 0;
      return total
        ? `${total} tarefa(s) vencida(s) aguardando ação.`
        : "Nenhuma tarefa atrasada.";
    },
    temperaturaOptions() {
      return [{ value: null, text: "Todas" }].concat(
        this.temperaturas.map((temperatura) => ({
          value: temperatura.chave,
          text: temperatura.nome,
        }))
      );
    },
    usuarioOptions() {
      return [{ value: null, text: "Todos" }].concat(
        this.usuarios.map((usuario) => ({
          value: usuario.id_usuario,
          text: usuario.nome || usuario.usuario,
        }))
      );
    },
  },
  mounted() {
    this.loadBase();
  },
  methods: {
    abrirAgenda(item) {
      this.$router.push({
        name: "crmAgendaEditar",
        params: { id: item.id_crm_agenda },
      });
    },
    abrirOportunidadesGanhas() {
      this.$bvModal.show("crm-ganhas-modal");
    },
    abrirOportunidade(item) {
      this.$router.push({
        name: "crmOportunidadeDetalhe",
        params: { id: item.id_crm_oportunidade },
      });
    },
    abrirOportunidadeGanha(item) {
      this.$bvModal.hide("crm-ganhas-modal");
      this.$router.push({
        name: "crmOportunidadeDetalhe",
        params: { id: item.id_crm_oportunidade },
        query: { origem: "ganhas" },
      });
    },
    abrirTarefa(item) {
      if (item.id_crm_oportunidade) {
        this.$router.push({
          name: "crmOportunidadeDetalhe",
          params: { id: item.id_crm_oportunidade },
        });
        return;
      }

      this.$router.push({ name: "crmTarefas" });
    },
    async loadBase() {
      await Promise.all([
        this.loadFunisFiltro(),
        this.loadUsuariosFiltro(),
        this.loadTemperaturasFiltro(),
      ]);

      await this.loadDashboard();
    },
    async loadFunisFiltro() {
      try {
        const funis = await crmService.funis();
        this.funis = this.normalizeCollection(this.responseData(funis));
      } catch (error) {
        this.funis = [];
        this.$toast.error("Não foi possível carregar os funis do CRM.");
      }
    },
    async loadUsuariosFiltro() {
      try {
        const usuarios = await crmService.usuarios({
          per_page: 100,
          page: 1,
          sort: [{ field: "nome", type: "asc" }],
        });
        this.usuarios = this.normalizeCollection(this.responseData(usuarios));
      } catch (error) {
        this.usuarios = [];
      }
    },
    async loadTemperaturasFiltro() {
      try {
        const temperaturas = await crmService.temperaturasConfiguracao();
        this.temperaturas = this.normalizeCollection(
          this.responseData(temperaturas)
        );
      } catch (error) {
        this.temperaturas = [];
      }
    },
    async loadDashboard() {
      if (!this.filtros.data_inicio || !this.filtros.data_fim) {
        this.$toast.error("Informe o período para carregar o dashboard.");
        return;
      }

      this.loading = true;
      try {
        const { data } = await crmService.dashboard(this.filtros);
        this.resumo = data;
      } catch (error) {
        this.$toast.error("Não foi possível carregar o dashboard CRM.");
      } finally {
        this.loading = false;
      }
    },
    defaultPeriodo() {
      const hoje = new Date();
      const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      return {
        data_inicio: this.toDateInput(inicio),
        data_fim: this.toDateInput(hoje),
        id_crm_funil: null,
        id_usuario: null,
        status: "Todos",
        temperatura: null,
      };
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(`${value}T00:00:00`).toLocaleDateString("pt-BR");
    },
    formatDateTime(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.data)) return data.data;
      return [];
    },
    prioridadeMotivos(item) {
      if (
        Array.isArray(item.motivos_prioridade) &&
        item.motivos_prioridade.length
      ) {
        return item.motivos_prioridade.join(" · ");
      }

      if (item.dias_parada) {
        return `Parada há ${item.dias_parada} dia(s)`;
      }

      return "Abrir para revisar próxima ação";
    },
    responseData(response) {
      const data = response ? response.data : null;
      return data && data.data ? data.data : data || {};
    },
    statusAgendaLabel(status) {
      const labels = {
        agendado: "Agendado",
        concluido: "Concluído",
        cancelado: "Cancelado",
        nao_compareceu: "Não compareceu",
      };
      return labels[status] || status || "Sem status";
    },
    statusContratoLabel(item) {
      if (!item || !item.id_crm_oportunidade_contrato) {
        return "Sem contrato gerado";
      }

      if (item.contrato_status === "ganha") {
        return "Contrato assinado";
      }

      return "Aguardando assinatura";
    },
    toDateInput(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
